import { Button } from "react-bootstrap";

import { EditIcon, ToolIcon } from "../../../../components/icons";
import type { ToolType } from "../../types";
import { DeleteToolModal } from "./DeleteToolModal";

interface TToolItemProps {
  tool: ToolType;
  handleEdit: (tool: ToolType) => void;
  handleDelete: (id: number) => void;
}

const ToolItem: React.FC<TToolItemProps> = ({
  tool,
  handleDelete,
  handleEdit,
}) => {
  const onEditClick = () => {
    handleEdit(tool);
  };

  return (
    <div key={tool.tool.function.name} className="tool-item">
      <div className="tool-item-name">
        <span>
          <ToolIcon />
        </span>{" "}
        <div className="text-truncate">{tool.tool.function.name}</div>
      </div>
      <Button
        variant="light"
        className="btn-tool-control"
        onClick={onEditClick}
      >
        <EditIcon />
      </Button>
      <DeleteToolModal
        handleDelete={handleDelete}
        toolId={tool.id}
        toolName={tool.tool.function.name}
      />
    </div>
  );
};

export { ToolItem };
